import styled from 'styled-components';

export const StyledShipmentsOverview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .info-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .metric-card {
    position: relative;

    .metric-direct {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .card-wrapper {
    position: relative;

    .Polaris-ShadowBevel {
      height: 100%;
    }

    &.locked {
      user-select: none;
      pointer-events: none;

      * {
        pointer-events: none !important;
        user-select: none !important;
      }
    }

    &.locked::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background-color: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(2px);
      border-radius: var(--p-border-radius-200);
      pointer-events: none;
      z-index: 1;
    }
  }

  .chart-wrapper {
    position: relative;

    &.locked {
      user-select: none;
      pointer-events: none;

      * {
        pointer-events: none !important;
        user-select: none !important;
      }
    }

    &.locked::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(2px);
      border-radius: var(--p-border-radius-400);
      pointer-events: none;
      z-index: 1;
    }
  }
`;
